import React from 'react'
import type { ComposeComponentDownloadableAssetFragment } from '../../../.graphql/generated-types'
import { ContentfulImageWithPlaceholder } from '../ContentfulImageWithPlaceholder'

export interface DownloadableAssetProps {
  data: ComposeComponentDownloadableAssetFragment
}

export function DownloadableAsset({ data }: DownloadableAssetProps) {
  if (
    data.asset?.url &&
    data.image?.imageAsset?.url &&
    data.image.imageAsset.width &&
    data.image.imageAsset.height
  ) {
    const { width, height, url } = data.image.imageAsset
    return (
      <div>
        <a href={data.asset.url} target="_blank" rel="noreferrer">
          <ContentfulImageWithPlaceholder
            width={width}
            height={height}
            src={url}
            alt={data.image.altText ?? ''}
          />
        </a>
      </div>
    )
  }
  return null
}
